export default "__VITE_ASSET__BMhbX$0L__"